<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>资源导出</span>
          </div>
          <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <label class="form-tit">创建日期 </label>
                <el-date-picker
                  :editable="false"
                  v-model="searchData.creationDate"
                  type="daterange"
                  unlink-panels
                  placeholder="选择日期"
                  class="jm-input280"/>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <label class="form-tit">签约日期 </label>
                <el-date-picker
                  :editable="false"
                  v-model="searchData.sign_date"
                  type="daterange"
                  unlink-panels
                  placeholder="选择日期"
                  class="jm-input280"/>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="grid-content bg-purple">
                <label class="form-tit">渠道 </label>
                <jm-channel :is-all="true" v-model="searchData.channels" clearable filter />
              </div>
            </el-col>
          </el-row>
          <div class="jm-primary">
            <el-button
              class="jm-input-common3"
              type="primary"
              :loading="exporting"
              @click="sendForm">导出资源</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jmToolbar from '@/components/tool/toolbar';
import jmTableList from '@/components/data/tableList';
import { jmChannel, } from '@/components/tool';
import moment from 'moment';

export default {
  data() {
    return {
      searchData: {
        creationDate: [],
        sign_date: [],
        channels: {}
      },
      exporting: false,
    };
  },
  components: { jmToolbar, jmTableList, jmChannel },
  methods: {
    // 表单提交
    sendForm() {
      this.exporting = true;
      let downloadName = '资源记录-当前状态.xlsx';
      this.exporting = false;
      this.searchData.creationDate = this.searchData.creationDate.map((v, index) => {
        let format = !index ? 'YYYY-MM-DD 00:00:00' : 'YYYY-MM-DD 23:59:59';
        return moment(new Date(v)).format(format);
      });
      this.searchData.sign_date = this.searchData.sign_date.map((v) => {
        return moment(new Date(v)).format('YYYY-MM-DD');
      });
      this.$http.downloadFile({
        filename: downloadName,
        data: this.searchData,
        url: '/training/Resource/resourceExport'
      });
    }
  }
};
</script>
